// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-wrapper .svg-pointer {\n  z-index: 2;\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  height: 100%;\n  top: auto;\n  background-color: var(--sd-primary-normal);\n}\n", ""]);
// Exports
module.exports = exports;
